export function ssrClientPerformanceMark(
  name: string,
  options?: PerformanceMarkOptions,
) {
  if (
    window &&
    window.performance &&
    typeof window.performance.mark === 'function'
  ) {
    window.performance.mark(`[SSR Client] ${name}`, options);
  }
}
